import React from 'react';
import styled, { css } from 'styled-components';
import { Box, Text } from '@sparknz/spark-pattern-library';

import { ResponseData } from '../../../types/bannerContent.types';

type URLAndDescription =
  ResponseData['data']['multiLineBannerModelList']['Banners'][0]['bannerDetails'][0]['urlAndDescription'][0];

type BannerItemProps = {
  urlAndDescription: URLAndDescription;
  isFirst?: boolean;
};

const DeviceGalleryBannerLink = styled.a`
  text-decoration: none;
  color: inherit;
  &:hover {
    text-decoration: underline;
  }
`;

const StyledBannerItem = styled(Box)`
  ${({ theme: { palette } }) => css`
    border-left: solid 1px ${palette.baseColors.mawheranui};
  `}
`;

const BannerItem = ({ urlAndDescription, isFirst }: BannerItemProps) => {
  const BannerLink = (
    <DeviceGalleryBannerLink href={urlAndDescription.urlLink} target="_blank">
      {urlAndDescription.urlName}
    </DeviceGalleryBannerLink>
  );

  const BannerText = <Text variant="bodySDemi">{BannerLink}</Text>;

  if (!urlAndDescription?.urlName) return null;
  if (isFirst) return BannerText;
  return <StyledBannerItem pl="s1">{BannerText}</StyledBannerItem>;
};

export default BannerItem;
